import {
  calculateFindingCvssDisplayScore,
  environmentalRequirementsForVersion,
  formatFindingCvssPillScore,
  getFindingCvssDisplayValues,
  isEnvironmentalRequirementsConfigured,
  stripEnvironmentalMetricsFromVector,
  toNonEmptyString,
  type CvssEnvironmentalRequirements,
  type FindingCvssFields,
  type FindingCvssVersionKey,
} from '@terra/shared-cvss';

export type FindingCvssEffectiveScore = {
  score: string | null;
  baseScore: string | null;
  isEnvironmental: boolean;
};

const formatScore = (value: unknown): string | null => {
  const text = toNonEmptyString(value);

  if (text === null) {
    return null;
  }

  const parsed = Number(text);

  return Number.isFinite(parsed) ? parsed.toFixed(1) : null;
};

export const resolveFindingCvssEffectiveScore = ({
  version,
  record,
  requirements,
}: {
  version: FindingCvssVersionKey;
  record: FindingCvssFields | null;
  requirements?: Partial<CvssEnvironmentalRequirements> | null;
}): FindingCvssEffectiveScore => {
  const baseScore = formatScore(record?.score);

  if (formatScore(record?.environmentalScore)) {
    return {
      score: formatFindingCvssPillScore(record),
      baseScore,
      isEnvironmental: true,
    };
  }

  const vector = getFindingCvssDisplayValues(record).vector;
  const resolved = environmentalRequirementsForVersion({
    requirements,
    version,
  });

  if (!vector || !isEnvironmentalRequirementsConfigured(resolved)) {
    return { score: baseScore, baseScore, isEnvironmental: false };
  }

  const displayed = calculateFindingCvssDisplayScore({
    vector: stripEnvironmentalMetricsFromVector(vector),
    environmentalRequirements: resolved,
  });

  return displayed
    ? {
        score: displayed.displayedScore.toFixed(1),
        baseScore: displayed.baseScore.toFixed(1),
        isEnvironmental: true,
      }
    : { score: baseScore, baseScore, isEnvironmental: false };
};
